export default {
    INVALLINFO: "/inv/wine/allInfo",
    INVALLNONMER: "/so/inv/allNonMer",
    INVWINESAVEORDER: "/inv/wine/saveOrder",
    INVWINECOURRIER: "/inv/wine/courrier",
    INVWINESAVETEMPORDER: "/inv/wine/saveTempOrder",
    INVWINEADDTEMPORDER: "/inv/wine/addTempOrder",
    INVWINECONSIGNEE: "/inv/wine/consignee",
    INVWINEDROPDOWN: "/inv/wine/dropdown",
    INVWINEVASINSTRUCTION:"/inv/wine/vasInstruction",
    INVWINEFINDTEMPSOORDERINFO: "/inv/wine/findTempSoOrderInfo",
    INVWINEFINDTEMPSOORDERNONMER: "/inv/nonMer/findTempSoOrderInfo",
    INVWINECLEARTEMP: "/inv/wine/clearTemp",
    INVSKU:"/mobile/wine/page2",
    INVWINEADDTEMPORDERNONMER: "/inv/nonMer/addTempOrder",
    INVWINERESETTEMPORDERNONMER: "/inv/nonMer/resetTempOrder",
    GETINVTEMPORDERNONMER:"/inv/nonMer/tempOrder",
    UDATECURRENTSTEP:"/inv/nonMer/currentStep"
}